import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconTotalInvoicing: React.FC<Props> = ({
  width = 12,
  height = 12,
  // color = "#FFFFFF",
  // disabled = false,
}: Props) => (
  <svg width={width} 
        height={height} 
        viewBox="0 0 12 12" fill="none" 
        xmlns="http://www.w3.org/2000/svg">

      <circle cx="6" cy="6" r="4.5" stroke="#BDB4FE" stroke-width="3"/>
  </svg>

  
);

export default IconTotalInvoicing;
